//Add constant attributes like messages
const constants = {
  APP_TITLE: process.env.REACT_APP_TITLE || "LocumScope ™",
  FACILITY: "Admin",
  DASHBOARD: "Dashboards",
  SCHEDULING: "Scheduling",
  SPEND_MANAGEMENT: "Spend",
  MY_PROFILE: "My Profile",
  SETTING: "Settings",
  LOGOUT: "Logout",
  ADD_FACILITY: "ADD FACILITY",
  ADD_FACILITY_BUTTON: "Add Facility",
  ADD_FACILITY_USERS: "Add facility users",
  SUCCESSFULLY: "User added successfully",
  ACTION_INVALID: "This action is invalid!",
  USERNAME: "Username",
  LOGIN_TITLE: "WELCOME TO",
  LOGIN_BUTTON_CONTINUE: "Ready to log in?",
  AGREE_TERMS_TEXT: "By Signing in, you agree to our",
  TERMS_SERVICE: "Terms of Service",
  TERMS_OF_POLICY: "Privacy Policy",
  BUTTON_CONTINUE: "Continue",
  AND: "and",
  EMAIL_PLACEHOLDER: "Email",
  SELECT_HOSPITAL: "Select Client",
  SELECT_WPRKSITE: "Select Facility",
  ORDER_BY: "Order By",
  BUTTON_SUBMIT: "Submit",
  SELECT_FACILITY: "Select Facility",
  FIELD_REQUIRED: "This field is required",
  REPORTS: "REPORTS",
  CANDIDATES: "Candidates",
  LOCUMS_ANALYTICS: "Locums Analytics",
  LANDING_PAGE: "Landing Page",
  SCHEDULING_REPORT: "Scheduled Providers Report",
  ADD_NEW_FACILITY: "ADD NEW FACILITY",
  BASIC_FACILITY_INFORMATION: "1.Basic Facility Information",
  FACILITY_NAME: "Facility Name",
  FACILITY_SUCCESSFULLY_MESSAGE: "Facility added successfully!",
  FACILITY_ALREADY_EXISTS: "Facility already exists",
  UPDATE_FACILITY: "EDIT FACILITY",
  UPDATE_FACILITY_SUCCESSFULLY_MESSAGE: "Facility updated successfully!",
  ACCOUNT_NAME: "Account Name",
  SELECT_ACCOUNT_NAME: "Select account name",
  FACILITY_INFORMATION: "1. Facility Information",
  ACCOUNT_STATUS: "Account Status",
  DEFINITIVE_ID: "Definitive ID",
  ACCOUNT_NUMBER: "Account Number",
  WEBSITE: "Website",
  TYPE: "Type",
  DASHBOARD_SUBSCRIPTION: "Dashboard Access",
  FACILITY_ADMIN: "2. Primary Contact",
  SELECT_ADMIN: "Select Admin",
  SELECT_CONTACT: "Select Contact",
  FULL_NAME: "Full Name",
  TITLE: "Title",
  PHONE_NUMBER: "Phone Number",
  EMAIL: "Email",
  BUTTON_RESET: "Reset",
  ACCOUNT_NAME_ERROR_MESSAGE: "This field is required",
  ADMIN_NAME_ERROR_MESSAGE: "This field is required",
  EDIT_FACILITY: "EDIT FACILITY",
  ADDRESS: "Address",
  FACILITY_DETAILS: "FACILITY DETAILS",
  FACILITY_USERS: "FACILITY USERS",

  FOOTER_COPYRIGHT: "© 2024 Copyright : Hayes Locums",
  LIMIT: 10000,
  MASTER_CALENDAR_LIMIT: 5000,
  ERROR_401_MESSAGE:
    "You are not authorized to perform this action. Please contact to support@locumscope.com",
  ERROR_403_MESSAGE:
    "Access to this resource is forbidden. Please contact to support@locumscope.com",
  ERROR_404_MESSAGE:
    "The requested resource could not be found. Please contact to support@locumscope.com",
  ERROR_503_MESSAGE:
    "The service is temporarily unavailable. Please try again later. Please contact to support@locumscope.com",
  ERROR_500_MESSAGE: "Facility already onboarded.",
  NO_RECORDS_FOUND: "No records available",
  REPORT_SUBMITTED_SUCCESSFULLY: "Reports submitted successfully",
  REPORT_SUBMISSION_FAILED: "Report submission failed",
  CLIENT_FIELD_IS_REQUIRED: "Client field is required !",
  REPORT_UPDATED_SUCCESSFULLY: "Report updated successfully",
  REPORT_UPDATION_FAILED: "Report updation failed",
  HOME: "Home",
  MY_FACILITY: "My Facility",
  EMPTY_ERROR_MESSAGE: "This field is required",
  PDF_EXTENSSION: "PDF",
  DOCX_EXTENSSION: "DOCX",
  PNG_EXTENSION: "png",
  JPG_EXTENSION: "jpg",
  XLSX_EXTENSION: "xlsx",
  ADD_FACILITY_USER: "ADD FACILITY USER",
  FACILITY_USER: "FACILITY USER",
  EDIT_FACILITY_USER: "EDIT FACILITY USER",
  PROFILE: "Profile",
  TIME_ENTRIES: "Time Entries",
  DOCUMENTS: "Documents",
  CALENDAR: "Calendar",
  TIMESHEET: "Timesheets",
  INVOICE: "Invoices",
  SHIFT: "Shifts",
  CREDENTIALING: "Credentialing",
  INACTIVE_MESSAGE: "Are you sure you want to inactivate this user?",
  ACTIVE_MESSAGE: "Are you sure you want to activate this user?",
  CONFIRMATION_TITLE: "Confirmation",
  WELCOME: "Welcome",
  EXPENSES: "Expenses",
  VIEW: "View",
  LINK: "Link",
  NO_FILE_AVAILABLE: "File not available",
  NO_DATA_AVAILABLE_MESSAGE: "No data available",
  NO_RECORD_FOUND_MESSAGE: "No records found",
  TABLEAU_SUBSCRIPTION_ERROR_MESSAGE:
    "The dashboard subscription is not available. Please contact to support@locumscope.com",
  DASHBOARD_NOT_FOUND_ERROR_MESSAGE:
    "Dashboard is not available. Please contact to support@locumscope.com",
  SUPPORT_HELP: "Support & Help",
  LOGIN_HELP_LINK: "Having trouble logging in? Get help",
  SUPPORT_EMAIL_TEMPLATE_SUBJECT: "Support Request",
  POWERED_BY: "Powered by",
  SECURE_LOGIN_VIA: "Secure login via Auth0",
  SUPPORT_EMAIL_TEMPLATE_BODY: [
    "Hello Support Team,",
    "",
    "I'm experiencing the following issue on the website:",
    "",
    "[Please describe your issue here]",
    "",
    "Additional details:",
    "- Browser: [Your browser]",
    "- Operating System: [Your operating system]",
    "",
    "Thank you,",
    "[Your Name]",
  ].join("\r\n"),
  YOUR_COMPLETE_VIEW: "YOUR COMPLETE VIEW",
  CLEARLY_DELIVERED: "CLEARLY DELIVERED",
  SSO_ENABLED: "SSO Enabled",
  WATERMARK_FOOTER_TEXT:
    "CONFIDENTIALITY NOTICE: This document contains Hayes Locums proprietary information from LocumScope. Unauthorized review, use, or distribution is strictly prohibited",
  WATERMARK_TEXT: "CONFIDENTIAL",
  WATERMARK_ANGLE_DEGREE: 45,
  ERROR_400_API_MESSAGE: "Bad request - the data sent is invalid.",
  ERROR_401_API_MESSAGE: "Unauthorized - please check your credentials.",
  ERROR_403_API_MESSAGE:
    "Access denied - you don’t have permission for this operation.",
  ERROR_404_API_MESSAGE:
    "Resource not found - please check the data or endpoint.",
  ERROR_405_API_MESSAGE: "Method Not Allowed → Request method not supported.",
  ERROR_406_API_MESAGE:
    "Not Acceptable → Response not acceptable based on headers.",
  ERROR_500_API_MESSAGE: "Internal server error- Please try again later.",
  ERROR_501_API_MESSAGE:
    "Not Implemented - Server doesn’t support this request method/feature.",
  ERROR_502_API_MESSAGE: "Bad Gateway → Invalid response from upstream server.",
  ERROR_503_API_MESSAGE:
    "Service is currently unavailable. Please try again later.",
  ERROR_504_API_MESSAGE: "Gateway Timeout → No response from upstream server.",
  ERROR_UNKNOWN_API: "An unexpected error occurred. Please contact support.",
  MESSAGE_LAST_PUBLISH_DATE: "Last Publish Date",
  CONFIRMATION_NOT_FOUND_OR_NO_ACCESS:
    "This confirmation could not be found or you do not have access to it.",
  CONFIRMATION_NOT_FOUND_HINT:
    "Please check the link from your email or go to Schedule Management to select a confirmation.",
  CALENDAR_LIMIT: 1000,
}
export default constants
